import { Box, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import styles from "./Order_Approval.module.css";
import { useNavigate } from "react-router-dom";

const sortOrdersByLatestFirst = (items) =>
  [...(Array.isArray(items) ? items : [])].sort((a, b) => {
    const aTime = new Date(
      a?.createdAt || a?.created_at || a?.updatedAt || a?.updated_at || 0,
    ).getTime();
    const bTime = new Date(
      b?.createdAt || b?.created_at || b?.updatedAt || b?.updated_at || 0,
    ).getTime();
    if (aTime !== bTime) return bTime - aTime;
    return Number(b?.id || 0) - Number(a?.id || 0);
  });

function OrderApproval({ orders, loading }) {
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  // const statusData = JSON.parse(import.meta.env.VITE_STATUS_DATA);

  useEffect(() => {
    setFilteredData(sortOrdersByLatestFirst(orders));
  }, [orders]);

  const clickCardHandler = (item, id, index) => {
    navigate(`/dashboard/tracking/${id}`, {
      state: {
        orders: orders,
        item: item,
        index: index,
        type: "order_approval",
      },
    });
  };

  return (
    <div>
      <div className={styles.Container}>
        {loading && (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <ul className={styles.List}>
          {Array.isArray(filteredData) &&
            filteredData.length !== 0 &&
            filteredData.map((item, index) => {
              const { id, marketplaceName, status, ticket_id } = item;
              return (
                <li key={id} className={styles.ListItem}>
                  <div
                    className={styles.Card}
                    onClick={() => {
                      clickCardHandler(item, ticket_id, index);
                    }}
                  >
                    <div className={styles.CardContent}>
                      <div className={styles.InfoSection}>
                        <h6 className={styles.Title}>{marketplaceName}</h6>
                        <div className={styles.InfoIds}>
                          <p className={styles.IdText}>Order Id : {id}</p>
                          <p className={styles.IdText}>
                            Ticket Id : {ticket_id}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={styles.StatusWrapper}>
                      <div
                        className={styles.StatusBadge}
                        // statusData[status]
                        // ? "text-white"
                        // : "bg-gray-800 text-white"

                        // style={
                        //   statusData[status]
                        //     ? {
                        //         backgroundColor: statusData[status],
                        //         borderColor: statusData[status],
                        //       }
                        //     : {}
                        // }
                      >
                        {status}
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
        </ul>
        {filteredData?.length === 0 && filteredData && !loading && (
          <div className={styles.EmptyContainer}>
            <center>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {/* <NoTrack style={{ height: "50vh" }}></NoTrack> */}
                <h2 style={{ margin: 0, marginLeft: "3%" }}>No Tickets Yet</h2>
                <p
                  style={{
                    marginTop: 0,
                    marginLeft: "3%",
                    fontSize: "12px",
                  }}
                >
                  Purchase Your First Software
                </p>
                <button
                  className={styles.PurchaseButton}
                  // onClick={() => navigate("/marketplace")}
                >
                  Purchase
                </button>
              </Box>
            </center>
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderApproval;
